<template>
  <v-container fluid class="width-80" v-if="getPermission('setting:view')">
    <v-layout>
      <v-flex>
        <h3
          class="font-weight-900 mb-4 font-size-36 custom-headline color-custom-blue"
        >
          Service Form
        </h3>
      </v-flex>
      <v-flex class="text-right">
        <v-btn
          class="custom-grey-border custom-bold-button"
          v-on:click="goBack"
        >
          <v-icon small left>mdi-keyboard-backspace</v-icon>
          Back
        </v-btn>
      </v-flex>
    </v-layout>

    <v-card flat class="custom-grey-border remove-border-radius">
      <v-card-title class="headline grey lighten-4">
        <v-row>
          <v-col md="6" class="py-0 my-auto">
            <h3
              class="font-weight-700 custom-headline color-custom-blue"
              style="margin: 3.5px 0px"
            >
              Service Form
            </h3>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text class="p-6 font-size-16">
        <perfect-scrollbar
          :options="{ suppressScrollX: true }"
          class="scroll custom-box-top-inner-shadow"
          style="max-height: 70vh; position: relative"
        >
          <div class="custom-listing-table">
            <v-simple-table
              class="simple-table"
              fixed-header
              :height="tableRows.length > 0 ? '400px' : '100px'"
            >
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="simple-table-th" width="50">#</th>
                    <th class="simple-table-th">Service Form</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(row, index) in tableRows"
                    :key="index"
                    v-on:click="showDetail(row)"
                  >
                    <td class="simple-table-td" width="50">{{ index + 1 }}.</td>
                    <td class="simple-table-td">{{ row.label }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
        </perfect-scrollbar>
      </v-card-text>
    </v-card>
    <Dialog :common-dialog="detailDialog">
      <template v-slot:title>Update Service Form</template>
      <template v-slot:body>
        <v-form>
          <v-row>
            <v-col md="12" class="pt-0">
              <label class="font-weight-700 font-size-16">
                <v-text-field
                  dense
                  filled
                  color="cyan"
                  :label="attributes.checklist.label"
                  v-model="attributes.checklist.label"
                  solo
                  flat
                  :disabled="pageLoading"
                  :loading="pageLoading"
                  hide-details
                  class="mr-2 hide-border"
                >
                </v-text-field>
              </label>
              <v-row dense>
                <v-col
                  md="6"
                  v-for="(row, key) in attributes.checklist.checkbox"
                  :key="key"
                >
                  <v-text-field
                    dense
                    filled
                    color="cyan"
                    :label="row.label"
                    v-model="row.label"
                    :disabled="pageLoading"
                    :loading="pageLoading"
                    solo
                    flat
                    hide-details
                  >
                    <template v-slot:prepend>
                      <v-checkbox
                        :disabled="pageLoading"
                        :value="1"
                        color="cyan"
                        class="hide-margin small"
                        hide-details
                        dense
                        v-model="row.value"
                      ></v-checkbox>
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>
            </v-col>
            <v-col md="12">
              <label class="font-weight-700 font-size-16">
                <v-text-field
                  dense
                  filled
                  color="cyan"
                  :label="attributes.textarea_one.label"
                  v-model="attributes.textarea_one.label"
                  :disabled="pageLoading"
                  :loading="pageLoading"
                  solo
                  flat
                  hide-details
                  class="mr-2 hide-border"
                >
                </v-text-field>
              </label>
              <v-textarea
                auto-grow
                dense
                filled
                color="cyan"
                :label="attributes.textarea_one.label"
                v-model="attributes.textarea_one.value"
                :disabled="pageLoading"
                :loading="pageLoading"
                solo
                flat
                hide-details
                row-height="25"
              ></v-textarea>
            </v-col>
            <v-col md="12">
              <label class="font-weight-700 font-size-16">
                <v-text-field
                  dense
                  filled
                  color="cyan"
                  :label="attributes.textarea_two.label"
                  v-model="attributes.textarea_two.label"
                  :disabled="pageLoading"
                  :loading="pageLoading"
                  solo
                  flat
                  hide-details
                  class="mr-2 hide-border"
                >
                </v-text-field>
              </label>
              <v-textarea
                auto-grow
                dense
                filled
                color="cyan"
                :label="attributes.textarea_two.label"
                v-model="attributes.textarea_two.value"
                :disabled="pageLoading"
                :loading="pageLoading"
                solo
                flat
                hide-details
                row-height="25"
              ></v-textarea>
            </v-col>
            <v-col md="12">
              <v-layout>
                <v-flex class="mr-2">
                  <label class="font-weight-700 font-size-16">
                    <v-text-field
                      dense
                      filled
                      color="cyan"
                      :label="attributes.dates.started_at.label"
                      v-model="attributes.dates.started_at.label"
                      :disabled="pageLoading"
                      :loading="pageLoading"
                      solo
                      flat
                      hide-details
                      class="mr-2 hide-border"
                    >
                    </v-text-field>
                  </label>
                  <DateTimePicker
                    :disabled="pageLoading"
                    :loading="pageLoading"
                    :label="attributes.dates.started_at.label"
                    v-model="attributes.dates.started_at.value"
                  ></DateTimePicker>
                </v-flex>
                <v-flex class="ml-2">
                  <label class="font-weight-700 font-size-16">
                    <v-text-field
                      dense
                      filled
                      color="cyan"
                      :label="attributes.dates.finished_at.label"
                      v-model="attributes.dates.finished_at.label"
                      :disabled="pageLoading"
                      :loading="pageLoading"
                      solo
                      flat
                      hide-details
                      class="mr-2 hide-border"
                    >
                    </v-text-field>
                  </label>
                  <DateTimePicker
                    :disabled="pageLoading"
                    :loading="pageLoading"
                    :label="attributes.dates.finished_at.label"
                    v-model="attributes.dates.finished_at.value"
                  ></DateTimePicker>
                </v-flex>
              </v-layout>
            </v-col>
            <v-col md="12">
              <label class="font-weight-700 font-size-16">
                <v-text-field
                  dense
                  filled
                  color="cyan"
                  :label="attributes.terms_conditions.label"
                  v-model="attributes.terms_conditions.label"
                  :disabled="pageLoading"
                  :loading="pageLoading"
                  solo
                  flat
                  hide-details
                  class="mr-2 hide-border"
                >
                </v-text-field>
              </label>
              <v-textarea
                auto-grow
                dense
                filled
                color="cyan"
                :label="attributes.terms_conditions.label"
                v-model="attributes.terms_conditions.value"
                :disabled="pageLoading"
                :loading="pageLoading"
                solo
                flat
                hide-details
                row-height="25"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-form>
      </template>
      <template v-slot:action>
        <v-btn
          v-on:click="detailDialog = false"
          class="mx-2 custom-grey-border custom-bold-button"
          depressed
        >
          Cancel
        </v-btn>
        <v-btn
          class="mx-2 custom-bold-button white--text"
          color="cyan"
          v-on:click="updateServiceFormSetting()"
        >
          Save
        </v-btn>
      </template>
    </Dialog>
  </v-container>
</template>

<script>
import { GET, PATCH } from "@/core/services/store/request.module";
import Dialog from "@/view/pages/partials/Dialog.vue";
import DateTimePicker from "@/view/pages/partials/DateTimePicker.vue";

export default {
  name: "profile-service-form-setting",
  data() {
    return {
      pageLoading: true,
      detailDialog: false,
      tableRows: [],
      serviceForm: null,
      attributes: {
        checklist: {
          label: "Check List",
          checkbox: [
            {
              label: "Clean Motor & Controller Compartment",
              value: null,
            },
            {
              label: "Clean Frame & Console Panel",
              value: null,
            },
            {
              label: "Check & Test Console For Abnormality",
              value: null,
            },
            {
              label: "Clean & Lubricate Running Deck",
              value: null,
            },
            {
              label: "Check Running Belt Alignment & Adjust Accordingly",
              value: null,
            },
            {
              label: "Check Running Belt Tightness & Adjust if Necessary",
              value: null,
            },
          ],
        },
        textarea_one: {
          label: "Service Rendered",
          value: null,
        },
        textarea_two: {
          label: "Engineer Remarks",
          value: null,
        },
        dates: {
          started_at: {
            label: "Started At",
            value: null,
          },
          finished_at: {
            label: "Finished At",
            value: null,
          },
        },
        terms_conditions: {
          label: "Terms & Conditions",
          value: null,
        },
      },
    };
  },
  methods: {
    showDetail({ id, attributes }) {
      this.detailDialog = true;
      this.serviceForm = id;
      this.attributes = attributes;
    },
    getServiceFormSetting() {
      const _this = this;
      _this.$store
        .dispatch(GET, { url: "setting/service-form" })
        .then(({ data }) => {
          _this.tableRows = data;
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },
    updateServiceFormSetting() {
      const _this = this;
      _this.pageLoading = true;
      _this.$store
        .dispatch(PATCH, {
          url: "setting/service-form/" + _this.serviceForm,
          data: { attributes: _this.attributes },
        })
        .then(({ data }) => {
          _this.tableRows = data;
          _this.detailDialog = false;
          _this.serviceForm = null;
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },
  },
  components: {
    DateTimePicker,
    Dialog,
  },
  mounted() {
    this.getServiceFormSetting();
  },
};
</script>
